/* eslint-disable react/jsx-indent */
import React, { useEffect } from 'react';
import { FiEdit } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CircularProgress } from '@material-ui/core';

import FormCamunda from '~/components/Formik/FormCamunda';
import BackButton from '~/components/Header/BackButton';
import { useAuth } from '~/hooks/auth';
import { IState } from '~/store';
import { getDynamicTableRequest } from '~/store/modules/dynamicTable/actions';
import {
  executeTaskRequest,
  getTaskFormRequest,
  getTaskRequest,
} from '~/store/modules/tasks/actions';
import { IGetTasksParams } from '~/store/modules/tasks/types';

import { Container, NoFormAvailable, LoadingContainer } from './styles';

type UseParams = {
  id: string;
};

const ExecuteTask = () => {
  const { id } = useParams<UseParams>();
  const { user } = useAuth();

  const task = useSelector((state: IState) => state.tasks.task);
  const taskAssigned = useSelector(
    (state: IState) => state.tasks.taskInstances,
  );
  const loadingTask = useSelector((state: IState) => state.tasks.loadingTask);
  const taskError = useSelector((state: IState) => state.tasks.errorStatus);
  const isExecutingTask = useSelector(
    (state: IState) => state.tasks.isExecutingTask,
  );

  const dispatch = useDispatch();

  const formCamundaTaskParams: IGetTasksParams = {
    assigned: true,
    assigneeIn: [],
    limit: 15,
    page: 1,
    sortBy: 'dueDate',
    sortOrder: 'asc',
    taskSearch: '',
  };

  useEffect(() => {
    if (task === undefined && !isExecutingTask) {
      dispatch(getTaskRequest(id, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (task && !task.form) {
      if (taskAssigned && task.id === taskAssigned[0].id) {
        dispatch(getTaskFormRequest(task));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [task]);

  useEffect(() => {
    const params = {};

    if (task && task?.dynamicTable && task.form) {
      task.form.forEach((element: any) => {
        if (element.props.id === 'dynamicTable') {
          Object.assign(params, {
            ...params,
            name: String(element.props.label),
            orgId: user.orgId,
          });
          dispatch(getDynamicTableRequest(params));
        }
      });
    }

    if (task?.variables) {
      task.variables.forEach((variable: any) => {
        if (variable.id === 'dynamicTable') {
          Object.assign(params, {
            ...params,
            name: String(variable.properties.dynamicTableName),
            orgId: user.orgId,
          });
          dispatch(getDynamicTableRequest(params));
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [task]);

  return (
    <Container>
      <BackButton
        to={
          (task?.deleteReason && task?.deleteReason !== null) ||
          taskError === 404 ||
          task?.assignee !== String(user.personId)
            ? `/tasks/disponiveis`
            : `/tasks/atribuidas`
        }
      />

      {!loadingTask ? (
        <>
          {task &&
            !task.deleteReason &&
            task?.form &&
            task.assignee === String(user.personId) && (
              <div>
                <h2>Execução tarefa: {task.name}</h2>
                <FormCamunda
                  process={task}
                  onSubmit={(variables, processFiles) => {
                    dispatch(
                      executeTaskRequest(
                        task.id,
                        formCamundaTaskParams,
                        user,
                        variables,
                        processFiles,
                        task?.rootProcessInstanceId,
                      ),
                    );
                  }}
                />
              </div>
            )}
          {task?.deleteReason === 'deleted' && task?.form && (
            <NoFormAvailable>
              <FiEdit size="80" color="#6c6c6c" />
              <h1>Tarefa cancelada</h1>
              <h3>Essa tarefa foi cancelada.</h3>
            </NoFormAvailable>
          )}
          {!loadingTask && task === undefined && taskError === 404 && (
            <NoFormAvailable>
              <FiEdit size="80" color="#6c6c6c" />
              <h1>Tarefa inexistente</h1>
              <h3>Essa tarefa não existe no sistema.</h3>
            </NoFormAvailable>
          )}
          {!loadingTask &&
            task?.form &&
            ((task?.assignee !== String(user.personId) &&
              task?.deleteReason !== 'deleted') ||
              (task?.assignee === String(user.personId) &&
                task?.deleteReason === 'completed')) && (
              <NoFormAvailable>
                <FiEdit size="80" color="#6c6c6c" />
                <h1>Tarefa Indisponível</h1>
                <h3>
                  Você não tem acesso a esta tarefa.
                  <br /> Tarefa já executada ou atribuída para outro usuário.
                </h3>
              </NoFormAvailable>
            )}
        </>
      ) : (
        <LoadingContainer>
          <CircularProgress size={32} color="inherit" />
        </LoadingContainer>
      )}
    </Container>
  );
};
export default ExecuteTask;
